<div class="disclaimer-container fluid-container">
  <div class="disclaimer-txt container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <span>
          <adp-label labelKey="Dashboard_NeedHelp_Text"></adp-label>
          <button class="link" (click)="openTutorial()">
            <adp-label labelKey="Dashboard_ViewTutorial_Text"></adp-label>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
